import React from 'react'
import styled from '@emotion/styled'
import { DESKTOP_BREAKPOINT } from 'src/constants/breakPoints'
import { useTheme } from 'src/shared/themeContext'
import { h1Style, pStyle, MAIN_FONT } from 'src/constants/fontStyles'

type ErrorPageProps = {
  title: string
  subtitle?: string
  content?: string | React.ReactNode
  fallbackContent?: React.ReactNode
  backgroundColor?: string
}

const ErrorPage = ({
  title,
  subtitle,
  content,
  fallbackContent,
  backgroundColor
}: ErrorPageProps) => {
  const { neutral, text } = useTheme()

  const Title = styled.div`
    font-family: ${MAIN_FONT};
    font-weight: 800;
    color: ${neutral.bluish};
    font-size: 100px;
    margin-bottom: 20px;
  `

  const Content = styled.div<{
    backgroundColor: string | undefined
  }>`
    font-family: ${MAIN_FONT};
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 60px;
    ${DESKTOP_BREAKPOINT} {
      background-color: ${props => props.backgroundColor || neutral.background};
    }
  `

  const Subtitle = styled.div`
    font-family: ${MAIN_FONT};
    font-style: normal;
    text-align: center;
    color: ${text.default};
    margin-bottom: 5px;
    word-break: break-word;
    ${h1Style}
  `

  const Body = styled.div`
    text-align: center;
    color: ${text.default};
    flex: none;
    order: 0;
    align-self: center;
    margin-bottom: 20px;
    ${pStyle}
  `

  return (
    <Content backgroundColor={backgroundColor}>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
      <Body>{content}</Body>
      {fallbackContent}
    </Content>
  )
}

export default ErrorPage
